<template>
  <div class="die">
    <img v-if="roll === 1" src="/assets/images/1.svg" alt="1">
    <img v-if="roll === 2" src="/assets/images/2.svg" alt="2">
    <img v-if="roll === 3" src="/assets/images/3.svg" alt="3">
    <img v-if="roll === 4" src="/assets/images/4.svg" alt="4">
    <img v-if="roll === 5" src="/assets/images/5.svg" alt="5">
    <img v-if="roll === 6" src="/assets/images/6.svg" alt="6">
  </div>
</template>

<script>
export default {
  props: {
    roll: { type: Number }
  }
};
</script>

<style scoped>
  img {
    width: 2.6rem;
  }
</style>
